// extracted by mini-css-extract-plugin
module.exports = {"shared":"button_shared__PI6Md","white":"button_white__tvnB1","black":"button_black__jReqO"};